import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { isTokenExpired } from "../utilis/auth";

const AdminRoute = ({ children }) => {
  const adminSession = useSelector((state) => state.user?.admin) || {};
  const { token = null, user = null, isLoggedIn = false } = adminSession;

  // Check if admin is not logged in or token is expired
  if (!isLoggedIn || !token || isTokenExpired(token)) {
    return <Navigate to="/admin/login" replace />;
  }

  // Check if user has admin role
  if (!user || user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
